import Header from "../Common/Header"
import { Container, Row, Col } from "react-bootstrap"
import { AppContext } from '../context/AppContext';
import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import MenuOptions from "./MenuOptions";
import Footer from "../Common/Footer";
import { Button } from "bootstrap";
import MenuOptionsReports from "./MenuOptionsReports";

function AdminMenu() {

    const { token, currentUser } = useContext(AppContext);

    return (
        <>
            <Container fluid="md" style={{ marginTop: '5px' }}>
                <Header titletext={"Administration"} />
                
                {/* <Row>
                    <Col>
                    <br></br><hr></hr>
                    <br></br>
                    </Col>
                </Row> */}

                <Row className="justify-content-center">
                    <Col xs={6} md={4} lg={3} className="mb-4">
                        <MenuOptions sImage={"/donations.png"} sTitle={"Donations"} sBody={"Donation Listing maintain"} sLink={"/donors"} sLinkLable={"Go to Donation List Maintain"} />
                    </Col>
                    <Col xs={6} md={4} lg={3} className="mb-4">
                    <MenuOptions sImage={"/danedates.png"} sTitle={"Dane Schedule"} sBody={"Dane dates calender"} sLink={"/danedates"} sLinkLable={"Go to Dane Dates Maintain"} />
                    </Col>
                    <Col xs={6} md={4} lg={3} className="mb-4">
                    <MenuOptionsReports sImage={"/reports.png"} sTitle={"Reports"} sBody={"Dane statistics reporting"} sLink={"/report/danecount"} sLinkLable={"Go to Dane Dates Count Report"} />
                    </Col>
                    {currentUser.accesstype ==="superadmin" &&
                    <Col xs={6} md={4} lg={3} className="mb-4">
                    <MenuOptions sImage={"/config.jpg"} sTitle={"Organization Setup"} sBody={"Organization Setup"} sLink={"/orgsetup"} sLinkLable={"Organization Setup"} />
                    </Col>}
                </Row>

                <Footer currentUser={currentUser} />

            </Container>
        </>
    )
}

export default AdminMenu;
